import React from "react";
import Img from "../Img";
import { useFavoriteEvents, useFavoriteEventsDispatch } from "./FavoriteEventsProvider";

export default function FavoriteEventToggle(props) {
    const favorites = useFavoriteEvents();
    const dispatch = useFavoriteEventsDispatch();

    let active = false;
    if (favorites?.[props.id] != null) {
        active = true;
    }

    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        dispatch({
            type: 'toggle',
            id: props.id
        });
    }

    return (
        <Img className={props.className} src={active ? 'icon_pin_active.svg' : 'icon_pin_default.svg'} height="32px" width="32px" onClick={handleClick} />
    );
}
